import styled from "styled-components";
import { palette, size, font } from "styled-theme";

const BaseModalButton = styled.button.attrs(({href}) => ({
  type: href ? undefined : "button",
  as: href ? "a" : "button"
}))`
  padding: 11px 44px;
  font-size: 12px;
  font-weight: ${font("headingWeight")};
  font-family: ${font("primary")};
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  border-radius: 25px;
  margin: 5px 0 5px 20px;
  min-width: 150px; 
  text-decoration: none;
  border-radius: ${size("borderRadius")};
  
  @media only screen and (max-width: ${size("M")}) {
    flex: 1;
    min-width: unset;
    white-space: break-spaces;
    padding: 11px 22px;
    max-width: 330px;
  }
`;

export const ModalButton = styled(BaseModalButton)`
  background: ${palette("modal", 1)};
  color: ${palette("color", 16)};
  border: none;

  &:hover {
    background: ${palette("button.default", 2)};
  }
`;

export const OutlineModalButton = styled(BaseModalButton)`
  border: 1px solid ${palette("modal", 0)};
  color: ${palette("modal", 0)};
  background: ${palette("color", 16)};
`
